function filtrationByBrand() {
  const form99 = document.querySelector(
    ".filter-section-parametric-id-99 form"
  );
  const form108 = document.querySelector(
    ".filter-section-parametric-id-108 form"
  );

  if (form99 && form108) {


    const checked = form99.querySelectorAll('input[type="checkbox"]:checked');
    const checkboxes99 = Array.from(form99.querySelectorAll('input[type="checkbox"]'));

    // Seřadíme podle textu z odpovídajícího labelu
    checkboxes99.sort((a, b) => {
      const labelA = form99.querySelector(`label[for="${a.id}"]`);
      const labelB = form99.querySelector(`label[for="${b.id}"]`);
      const textA = labelA ? labelA.textContent.trim() : "";
      const textB = labelB ? labelB.textContent.trim() : "";
      return textA.localeCompare(textB, undefined, { sensitivity: 'base' });
    });

    // Přeskládání checkboxů v DOM podle toho
    const parent99 = form99.querySelector('fieldset') || form99; // upravte podle struktury
    checkboxes99.forEach((cb) => {
      if (cb.parentElement && parent99.contains(cb.parentElement)) {
        parent99.appendChild(cb.parentElement);
      }
    });

    if (checked.length === 0) {
      form108.parentElement.classList.add("disabled");

      form108
        .querySelectorAll('input[type="checkbox"]')
        .forEach((cb) => (cb.disabled = true));
      return;
    } else {
      form108.parentElement.classList.remove("disabled");
      form108
        .querySelectorAll('input[type="checkbox"]')
        .forEach((cb) => (cb.disabled = false));
    }

    const znackaValues = [];
    checked.forEach((input) => {
      const id = input.id || "";
      const valueMatch = id.match(/\d+$/);
      const value = valueMatch ? valueMatch[0] : "";
      if (value) {
        znackaValues.push(value);
      }
    });

    // Tohle už není potřeba, protože vracíme už v předchozí větvi
    //if (znackaValues.length === 0) {
    //  console.warn("Žádné hodnoty k odeslání, zpracování přerušeno.");
    //  return;
    //}

    const formData = new FormData();
    znackaValues.forEach((val) => formData.append("znacka[]", val));
    showLoadingOverlay(form108);

    fetch("https://renomag-prod.axfone.eu/filter", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) throw new Error("Síťová chyba: " + response.status);
        return response.json();
      })
      .then((result) => {
        if (form108) {
          hideLoadingOverlay(form108);
          const checkboxes = form108.querySelectorAll('input[type="checkbox"]');

          const sortedKeys = Object.keys(result).sort((a, b) => {
            return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
          });

          const allowedIds = new Set(sortedKeys);

          checkboxes.forEach((checkbox) => {
            const idValueMatch = checkbox.id.match(/\d+$/);
            const idValue = idValueMatch ? idValueMatch[0] : "";
            const label = document.querySelector(`label[for="${checkbox.id}"]`);
            function getCleanText(label) {
              let cleanText = '';
              label.childNodes.forEach(node => {
                if (node.nodeType === Node.TEXT_NODE) {
                  cleanText += node.textContent;
                } else if (node.nodeType === Node.ELEMENT_NODE && !node.classList?.contains('filter-count')) {
                  cleanText += node.textContent;
                }
              });
              return cleanText;
            }

            const originalText = getCleanText(label);
            const cleanText = originalText.replace(/^.*?@/, '');

            label.textContent = cleanText;
            label.value = cleanText;

            const parent = checkbox.parentElement;

            if (allowedIds.has(idValue)) {
              checkbox.disabled = false;
              if (label) label.classList.remove("disabled");
              if (parent) parent.style.setProperty("display", "");

            } else {
              checkbox.disabled = true;
              checkbox.checked = false;
              if (label) label.classList.add("disabled");
              if (parent) parent.style.setProperty("display", "none");
            }

          });

          // Kontrola, jestli je nějaký checkbox viditelný (display !== 'none')
          const anyVisible = Array.from(checkboxes).some((chk) => {
            return (
              chk.parentElement &&
              getComputedStyle(chk.parentElement).display !== "none"
            );
          });

          // Najdi nebo vytvoř element pro zprávu
          let msg = form108.querySelector(".no-models-message");
          if (!anyVisible) {
            if (!msg) {
              msg = document.createElement("div");
              msg.classList.add("no-models-message");
              msg.style.marginTop = "10px";
              msg.style.fontStyle = "italic";
              msg.style.color = "#555";
              msg.textContent = "Vašemu výběru neodpovídá žádný model";
              form108.appendChild(msg);
            }
            msg.style.display = "block";
          } else {
            if (msg) {
              msg.style.display = "none";
            }
          }

        }
        setupPagination(form108, 10);
        [form99, form108].forEach((form) => {
          if (!form) return;
          form.addEventListener("change", (e) => {
            if (e.target && e.target.type === "checkbox") {
              const checkboxes = form.querySelectorAll('input[type="checkbox"]');
              if (e.target.checked) {
                checkboxes.forEach((cb) => {
                  if (cb !== e.target) cb.disabled = true;
                });
              } else {
                checkboxes.forEach((cb) => {
                  cb.disabled = false;
                });
              }
            }
          });
          // Při načtení stránky zkontrolovat stav
          const checked = form.querySelector('input[type="checkbox"]:checked');
          if (checked) {
            form.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
              if (cb !== checked) cb.disabled = true;
            });
          }
        });
      })
      .catch((error) => {
        hideLoadingOverlay(form108);
        console.error("Chyba:", error);
      });
  }
}

function showLoadingOverlay(form) {
  let overlay = form.querySelector(".loading-overlay");
  if (!overlay) {
    overlay = document.createElement("div");
    overlay.classList.add("loading-overlay");
    overlay.style.position = "absolute";
    overlay.style.top = "0";
    overlay.style.left = "0";
    overlay.style.width = "100%";
    overlay.style.height = "100%";
    overlay.style.backgroundColor = "rgba(255, 255, 255, 0.8)";
    overlay.style.display = "flex";
    overlay.style.justifyContent = "center";
    overlay.style.alignItems = "center";
    overlay.style.zIndex = "1000";
    overlay.style.fontSize = "1.2em";
    overlay.style.color = "#333";
    overlay.textContent = "Získávám data...";

    // Ujistěte se, že rodič má position: relative nebo absolute
    const computedPosition = window.getComputedStyle(form).position;
    if (computedPosition === "static" || !computedPosition) {
      form.style.position = "relative";
    }

    form.appendChild(overlay);
  }
  overlay.style.display = "flex";
}

function hideLoadingOverlay(form) {
  const overlay = form.querySelector(".loading-overlay");
  if (overlay) {
    overlay.style.display = "none";
  }
}

function setupPagination(target) {
  // Normalizace vstupu: selector | form element | NodeList/Array
  let forms = [];
  if (typeof target === "string") {
    forms = Array.from(document.querySelectorAll(target));
  } else if (target instanceof HTMLFormElement) {
    forms = [target];
  } else if (
    (typeof NodeList !== "undefined" && target instanceof NodeList) ||
    Array.isArray(target)
  ) {
    forms = Array.from(target).filter((el) => el instanceof HTMLFormElement);
  } else {
    console.warn("setupPagination: neznámý typ targetu, končím.");
    return;
  }
  if (!forms.length) return;

  forms.forEach((form) => {
    function render() {
      // Bereme pouze NE-disabled checkboxy i zaškrtnuté
      const all = Array.from(form.querySelectorAll('input[type="checkbox"]'));
      const checked = all.filter((c) => c.checked);
      const enabled = all.filter((c) => !c.disabled);

      // Schovat vše
      all.forEach((c) => {
        if (c.parentElement) c.parentElement.style.display = "none";
      });

      // Zaškrtnuté ukázat vždy
      checked.forEach((c) => {
        if (c.parentElement) c.parentElement.style.display = "";
      });

      // Všechny nezaškrtnuté enabled také zobrazit
      enabled
        .filter((c) => !c.checked)
        .forEach((c) => {
          if (c.parentElement) c.parentElement.style.display = "";
        });
    }

    form.addEventListener("change", (e) => {
      if (e.target && e.target.matches('input[type="checkbox"]')) {
        render();
      }
    });

    render();
  });
}

const removeFiltersCount = () => {
  const filterElements = document.querySelectorAll(".filter-section form fieldset>div");
 if (!filterElements.length) return;
  filterElements.forEach((el) => {
    const countSpan = el.querySelector(".filter-count");
    if (countSpan) {
      countSpan.remove();
      
    }
  });
}
export { filtrationByBrand, setupPagination, removeFiltersCount };